import React from 'react';
import './circlecta.css'
import pic41  from '../../assets/pic41.png'

const Circlecta = (props) => {
    return ( 
                                 <button className='circle-add-about'   onClick={props.onClick}   >
                                        <img src={pic41} alt=''></img>
                                </button>


     );
}
 
export default Circlecta;